<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-select
          v-model="v.identityDocument.code.$model"
          :errorMessages="getValidationErrorText(v.identityDocument.code)"
          :items="identityDocuments"
          item-value="code"
          item-text="title"
          label="Тип документа"
          @change="changeCode"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Серия документа"
          outlined
          v-model="v.identityDocument.series.$model"
          :errorMessages="getValidationErrorText(v.identityDocument.series)"
          v-mask="token.series"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">{{ mdiHelpCircle }}</v-icon>
              </template>
              <Hint>
                <template v-slot:text>
                  <div>
                    Необходимо указать серию документа в формате:
                    {{ token.series.mask }}
                  </div>
                </template>
                <template v-slot:body>
                  <ul style="margin-left: 30px; margin-top: 5px">
                    <li
                      v-for="(item, index) in hints(token.series.mask)"
                      :key="index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </template>
              </Hint>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Номер документа"
          outlined
          v-model="v.identityDocument.number.$model"
          :errorMessages="getValidationErrorText(v.identityDocument.number)"
          v-mask="token.number"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">{{ mdiHelpCircle }}</v-icon>
              </template>
              <Hint>
                <template v-slot:text>
                  <div>
                    Необходимо указать номер документа в формате:
                    {{ token.number.mask }}
                  </div>
                </template>
                <template v-slot:body>
                  <ul style="margin-left: 30px; margin-top: 5px">
                    <li
                      v-for="(item, index) in hints(token.number.mask)"
                      :key="index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </template>
              </Hint>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators';
import { mdiHelpCircle } from '@mdi/js';

import { EMOJI, getValidationErrorText } from '@/utils/validate';
import { getIdentityDocumentToken } from '@/utils/services';
import hints from '@/utils/mask';
import Hint from '@/components/base/Hint.vue';
import { IdentityDocumentCode } from '@/constants';
import { AuthModule } from '@/store/modules/auth';
import { IdentityDocumentsRodModule } from '@/store/modules/identityDocumentsRod';

export const identityDocumentModel = {
  code: IdentityDocumentCode.PASSPORT_RUSSIA_FEDERATION,
  number: '',
  series: '',
};

export const identityDocumentValidation = {
  code: {
    required,
  },
  number: {
    maxLength: maxLength(25),
    EMOJI,
    required,
  },
  series: {
    maxLength: maxLength(25),
    EMOJI,
    required: requiredIf((vm) => vm.code === '21'),
  },
};

export default {
  name: 'IdentityDocument',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    Hint,
  },
  data: () => ({
    getValidationErrorText,
    mdiHelpCircle,
    hints,
  }),
  async mounted() {
    if (
      !IdentityDocumentsRodModule.loading &&
      !IdentityDocumentsRodModule.loaded
    ) {
      await IdentityDocumentsRodModule.loadAll();
    }
  },
  computed: {
    identityDocuments() {
      return IdentityDocumentsRodModule.list;
    },

    token() {
      return getIdentityDocumentToken(this.v.identityDocument.code.$model);
    },

    user() {
      return AuthModule.user;
    },
  },
  methods: {
    changeCode() {
      this.v.identityDocument.$reset();

      if (
        this.v.identityDocument.code.$model ===
        IdentityDocumentCode.PASSPORT_RUSSIA_FEDERATION
      ) {
        this.v.identityDocument.number.$model =
          this.user.identityDoc.number || '';
        this.v.identityDocument.series.$model =
          this.user.identityDoc.series || '';
      } else {
        this.reset();
      }
    },
    reset() {
      // некорректно работает сброс series без setTimeout, возможно из-за маски
      setTimeout(() => {
        this.v.identityDocument.number.$model = '';
        this.v.identityDocument.series.$model = '';
      }, 0);
    },
  },
};
</script>
